import { createSlice } from "@reduxjs/toolkit";
// import addSuperadminDetailsApi from "@custom/rtk-apis/masterSuperAdminProfile/addSuperadminDetail";
import addEditCreditPerGbApi from "@custom/rtk-apis/masterSuperAdminProfile/addEditCreditPerGb";

const initialState = {
  status:"",
  result:{},
  msg:"",
  loading:false,
  error:""

};

const addEditCreditPerGbSlice = createSlice({
  name: "addEditCreditPerGbSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(addEditCreditPerGbApi.pending, (state, action) => {
        console.log("Pending")
        state.loading = true;
      })
      .addCase(addEditCreditPerGbApi.fulfilled, (state, { payload }) => {
        console.log("Fulfilled",payload)
        state.loading = false;
        state.status = payload.status;
        state.result = payload.result;
        state.msg = payload.msg;
      })
      .addCase(addEditCreditPerGbApi.rejected, (state, { payload }) => {
        console.log("Rejected")
        state.result = payload;
        state.loading = false;
      });
  },
});

export default addEditCreditPerGbSlice.reducer;
